var map = {
	"./breakfast_bistro_menu1.png": "63f1",
	"./breakfast_bistro_menu2.png": "73f2",
	"./breakfast_bistro_menu3.png": "a6a8",
	"./breakfast_bistro_menu4.png": "52fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c763";